import { Checkbox, Drawer, Form, Modal, Progress, Tooltip } from "antd";
import styled from "styled-components";
import { DataHeading, DataValue, GhostButtonComponent, InvestmentOption, SectionHeading } from "../../../../CommonComponents/commonStyles";


export const FormItemContainer = styled(Form.Item)`    
  .ant-form-item-children {
    position: static;
  }
  .ant-form-item-label label {
    color: ${props => props.theme.fontColors.textColor} !important; 
  }
  @media (max-width: 991px) {
    .ant-form-item-label label {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
`;
export const CPFormItem = styled(Form.Item)`
  margin-bottom:50px!important;
`;

export const EmptyBlock = styled.div`
  margin-bottom:40px;
`;

export const NewSectionHeading = styled(SectionHeading)`
  margin-bottom:15px !important;

  @media (max-width:767px) {
    margin-bottom:5px;
    height: 42px;
  }    
  letter-spacing: ${props => props.theme.letterSpacing.normal};
`;

export const UPCheckbox = styled(Checkbox)`
.ant-checkbox-inner{
  border-radius:50% !important;
}
`;

export const UserIdForm = styled(Form)`
  &&& {
    .ant-form-item {
      margin-right: 0px;
      margin-bottom: 40px;
    }
    .ant-form-item-required::before {
      content: "";
    }
    .ant-form-item-label label {
      color: #4a4a4a;
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: ${props => props.theme.fontSize.primary};
    }
    @media (max-width:767px) {
      margin-top: 40px;
    }
    .ant-form-item-children {
      position: static;
    }
    .ant-form-item-label>label:after {
      content: "";
    }
  }
`;

export const TooltipContainer = styled(Tooltip)`
  &&& {
    .ant-tooltip-inner {
      padding: 20px 30px !important;
    }
    .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
      margin-left: 0px;  
    }
  }
`;

export const TooltipHeading = styled(DataHeading)`
  font-size: ${props => props.theme.fontSize.secondary};
  color: white;
`;

export const ErrorMessage = styled(DataValue)`
     color: ${ props => props.theme.fontColors.error};
     position: absolute;
`;

export const ErrorMessageExceptional = styled(DataValue)`
    color: ${ props => props.theme.fontColors.error};
    font-family: ${ props => props.theme.fontFamily.helveticaNeue};
    padding-top: 5px;
    position: relative;
`;
export const InfoMessage = styled(DataValue)`
  width: 340px;
  height: auto;
  margin-top: 5px
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #dcdcdc;
  background-color: rgba(0, 103, 120, 0.9);
  position: relative;
  @media (max-width: 767px) {
    width: 100% !important;
  }
`;
export const InfoMessageContent = styled(DataValue)`
  width: 340px;
  height: auto;
  font-family: ${ props => props.theme.fontFamily.helveticaNeue};
  font-size: ${ props => props.theme.fontSize.secondary};
  line-height: ${ props => props.theme.lineHeight.primary};
  letter-spacing: ${ props => props.theme.letterSpacing.normal};
  color: ${ props => props.theme.colors.white};
  text-align : left;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  @media (max-width: 767px) {
    width: 100% !important;
  }
}`;

export const StrengthDiv = styled.div`
  margin-bottom: -24px;
`;

export const ProgressBar = styled(Progress)`
  position: relative;
  bottom: 15px;
`;

export const CustomModal = styled(Modal)`
  &&&{
    .ant-modal-header, .ant-modal-footer{
      display:none;
    }
  }
`

export const CustonGhostButtonComponent = styled(GhostButtonComponent)`
width: 60% !importanat;
@media only screen and (min-width: 320px) and (max-width: 767px) {
width: 50% !importanat;
}
`
export const ToolTipSpan = styled.span`
  margin-left: 30%;
  margin-top: 1px;
  position: absolute;
  top: -5px;
  height: 6px;
  border-radius: 100% 100% 1 2;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #006778;
  z-index: 1;
  left: 39px;
`;
export const TooltipContent = styled.span`
  width: 200px;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #dcdcdc;
  background-color: rgba(0, 103, 120, 0.9);
`;
export const CustomisedDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 692px !important;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }
  .ant-drawer-body {
    padding: 0 !important;
  }

  .ant-btn-primary {
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.fontColors.primary};
    width: 300px;
    height: 40px;
    border-radius: 0rem;
    border-color: transparent;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }
  .ant-drawer-close i svg {
    height: 24.8px;
    width: 25px;
    display: none;
  }
  .has-error .ant-form-explain {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
`;
export const DrawerSectionContent = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.secondary};
  color: ${props => props.theme.fontColors.thead};
  @media (max-width:767px) {
    margin-bottom:5px !important;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const CustomisedForm = styled(Form)`
  margin-top: 3rem;
  .ant-form-item-label {
    white-space: initial !important;
  }
  .ant-form-item-label > label::after {
    content: none !important;
    position: relative;
    top: -0.5px;
    margin: 0 8px 0 2px;
  }
  .ant-form-item-control-wrapper {
    width: 18.75rem;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }

  .ant-form-item {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: ${props => props.theme.fontSize.secondary};
    font-variant: tabular-nums;
    line-height: ${props => props.theme.lineHeight.primary};
    list-style: none;

    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum", "tnum";
    margin-bottom: 3.125rem !important;
    vertical-align: top;    
  }
 
  @media (max-width:767px) {
    margin-top: 40px;
  }
  .ant-form-explain {
    position: absolute;
  }
  .ant-form-item-control {
    line-height: 16px;
  }
  .ant-form-item-children {
    position: static;
  }
`;
export const FormLabel = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.oneP17};
  color: ${props => props.theme.fontColors.headingColor};
  padding-bottom: 1.25rem;

  @media (max-width:767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    padding-bottom: ${props => props.theme.spacing.paddings.noPadding};
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
  @media only screen and (max-width: 990px) {
   &&.myProfileSecurityQuestion, &&.myProfileSecurityQuestion div {
    letter-spacing: ${props => props.theme.letterSpacing.zero};  
    line-height: ${props => props.theme.lineHeight.secondary} !important;
    font-size: ${props => props.theme.fontSize.secondary};
   }
  }
`;
export const SecQuest = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.colors.tabHead};
  padding-top: 0.625rem;

  @media (max-width:767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    font-stretch: normal;
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
  @media only screen and (max-width: 990px) {
     letter-spacing: ${props => props.theme.letterSpacing.zero};  
  }
`;
export const Snag = {
  fontFamily: `${props => props.theme.fontFamily.berkeleyStd} !important`
}
export const DrawerContainer = styled.div`
  padding: 3.75rem 5rem 0 5rem;
  padding-left: 50px;
  padding-top: 50px;  
  @media (max-width: 767px) {
    padding: 50px;
    padding-top: 40px;
    padding-left: 22px; 
  }
  @media (min-width: 767px) {
    padding-right: 110px;
  }
`;
export const HitASnag = styled(InvestmentOption)`
  color: ${props => props.theme.fontColors.headingColor};
  &:hover {
    color: ${props => props.theme.fontColors.headingColor};
  }
  @media (max-width: 767px) {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: ${props => props.theme.fontSize.h5};
    font-weight:${props => props.theme.fontWeight.normal};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.h5} !important;
    line-height: ${props => props.theme.lineHeight.h5} !important;
  }
`;
export const ErrorResponse = styled.div`
  padding: 20px 0px 20px 0px;
  color: ${props => props.theme.colors.error};
  position: absolute;
  padding-top: 2px;
`;
export const SuccessImg = styled.img`
    width: 64px;
    height: 64px;
    margin-top: 30px;
    margin-bottom: 30px;
`
export const FormItem = styled(Form.Item)`
  .ant-form-item-label label {
    color: ${props => props.theme.fontColors.textColor} !important; 
  }
  @media (max-width: 991px) {
    .ant-form-item-label label {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
`;